module.exports = __webpack_public_path__ + "img/s2.8b307eef.png";